/**
 * @desc 保存处理订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.OrderParamRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/handlerOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
